import { observer } from 'mobx-react';
import { formatDate } from 'src/utils/helpers';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

const PickupCustomerInfo = observer(() => {
  const { store: orderStore } = useOrderStoreContext();
  if (!orderStore.order) return null;

  return (
    <div className="pickup-customer mr-6">
      <OrderBlockHeader title="Customer" />
      <ul className="d-flex flex-column">
        <OrderBlockItem title="hint_name" titleClassName="pickup-customer__item-title" data={orderStore.order.customer_first_name} />
        <OrderBlockItem title="txt_mobile" titleClassName="pickup-customer__item-title" data={orderStore.order.customer_mobile} />
        {orderStore.order.customer_email ? (
          <OrderBlockItem title="hint_email_id" titleClassName="pickup-customer__item-title" data={orderStore.order.customer_email} />
        ) : null}
        <OrderBlockItem title="Order Creation Time" titleClassName="pickup-customer__item-title" data={formatDate(orderStore.order.created_at, {})} />
      </ul>
    </div>
  );
});

export default PickupCustomerInfo;
